module.exports = {"title":"Qual o motivo da sua contestação?"}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/Contestation/data.json
// module id = 1833
// module chunks = 0